import { withInstall } from '@ll-plus/utils'

import CustomSearcher from './src/custom-searcher.vue'

export const LlCustomSearcher = withInstall(CustomSearcher)
export default LlCustomSearcher
export * from './src/custom-searcher'

declare module 'vue' {
  export interface GlobalComponents {
    LlCustomSearcher: typeof CustomSearcher
  }
}
